import { Button, Input, notification, Spin } from "antd";
import { useState } from "react";
import { EmailSearchIcon } from "themes/Icon";
import "./input_comp.scss";

const EmailSearchInput = ({
  onSave,
  onChange, // NEW: add onChange prop
  labelClass,
  label,
  setLoading = () => {},
}) => {
  const [email, setEmail] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [loading, setLoadingState] = useState(false);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSearch = async (value) => {
    if (validateEmail(value)) {
      setEmail(value);
      setIsValid(true);
      setLoading(true);
      setLoadingState(true);
      try {
        await onSave(value); // Call verification from parent
      } catch (error) {
        notification["error"]({
          message: "Verification Failed",
          description: "Failed to verify email.",
          duration: 2.5,
        });
      } finally {
        setLoading(false);
        setLoadingState(false);
      }
    } else {
      setIsValid(false);
      notification["warning"]({
        message: "Invalid Email",
        description: "Please enter a valid email address.",
        duration: 2.5,
      });
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setIsValid(true);
    if (onChange) onChange(value); // Send to parent
  };

  return (
    <div className="email-search gap-2">
      <label className={`${labelClass || "input-label"}`}>{label}</label>
      <Spin spinning={loading}>
        <Input.Search
          value={email}
          onChange={handleChange}
          onSearch={handleSearch}
          size="large"
          placeholder="Enter email address"
          enterButton={<Button type="primary" icon={<EmailSearchIcon />} />}
          status={!isValid && "error"}
          style={{ width: "100%" }}
        />
      </Spin>
    </div>
  );
};

export default EmailSearchInput;
